/* dashboard-rediseno, segunda vuelta (D18): EL PANEL DE FOTOS EN SU VENTANA (F5).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   El documento (F5 y H): en computadora y tablet, la ventana ancha de 720 px centrada (fondo
   #161616, borde #2A2A2A, radio 20, sobre negro al 66 %); en el telefono, la hoja desde abajo a lo
   ancho con radio 24 arriba, su agarradera y el boton fijo al fondo (lo de adentro se desplaza y el
   pie no). Adentro va `PanelFotos` tal cual, con su contenido y su conducta de hoy (`enVentana`
   solo le parte el cuerpo y el pie).

   Cerrar es cancelar (descarta las fotos elegidas), asi que ni el fondo ni Esc la cierran: solo la
   X y "Cancel", que son el mismo gesto. Sin portal: vive al lado de la pagina del Panel, fuera de
   su animacion de entrada (un ancestro con transformacion le cambiaria el `fixed`).

   marca-1 (#726): la agarradera cierra como la X (bajarla 80 o un tiron; si la X esta apagada, la hoja regresa), y la
   hoja entra y sale como las demas (`useHojaDeLaCasa`). La X queda encima del area de la agarradera. */
import React from 'react';
import { X } from 'lucide-react';
import { AreaDe44 } from './anatomia';
import { useHojaDeLaCasa, FilaDeAgarradera, ENTRA_EL_VELO, ENTRA_LA_CAJA } from '../alumno/arrastreDeHoja';

export const FONDO_DE_FOTOS = 'fixed inset-0 z-[70] flex items-end md:items-center justify-center bg-black/[0.66] md:p-4';
export const CAJA_DE_FOTOS = 'relative w-full md:max-w-[720px] max-h-[90dvh] flex flex-col bg-[#161616] border border-[#2A2A2A] rounded-t-[24px] md:rounded-[20px] shadow-2xl';

export default function VentanaDeFotos({ children, alCerrar, cerrarApagado = false, etiqueta, etiquetaCerrar }) {
  const hoja = useHojaDeLaCasa(alCerrar, { cerrable: !cerrarApagado });
  return (
    <div ref={hoja.veloRef} className={`${FONDO_DE_FOTOS} ${ENTRA_EL_VELO}`} data-testid="ventana-fotos-fondo">
      <div ref={hoja.cajaRef} role="dialog" aria-modal="true" aria-label={etiqueta} className={`${CAJA_DE_FOTOS} ${ENTRA_LA_CAJA}`} data-testid="ventana-fotos">
        <FilaDeAgarradera agarradera={hoja.agarradera} testid="ventana-fotos-agarradera"
          clase="md:hidden relative flex justify-center pt-2.5 shrink-0" />
        <button type="button" onClick={alCerrar} disabled={cerrarApagado} aria-label={etiquetaCerrar}
          className="absolute z-[2] top-2 right-2 w-9 h-9 rounded-xl flex items-center justify-center text-[#9A9A9A] hoverable:text-[#F4F4F3] hoverable:bg-[#1B1B1B] disabled:opacity-45"
          data-testid="ventana-fotos-cerrar">
          <AreaDe44 />
          <X className="w-4 h-4" aria-hidden="true" />
        </button>
        {children}
      </div>
    </div>
  );
}
